(function () {
  var popup = document.getElementById('EmailPopup');
  if (!popup) return;

  var DISMISS_KEY = 'welovematcha_popup_dismissed';

  function show() {
    popup.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        popup.classList.add('email-popup--visible');
      });
    });
  }

  function dismiss() {
    popup.classList.remove('email-popup--visible');
    setTimeout(function () {
      popup.hidden = true;
    }, 300);
    try {
      window.localStorage.setItem(DISMISS_KEY, '1');
    } catch (e) {}
  }

  popup.querySelectorAll('[data-popup-close]').forEach(function (el) {
    el.addEventListener('click', dismiss);
  });

  var copyButton = popup.querySelector('[data-copy-button]');
  if (copyButton) {
    copyButton.addEventListener('click', function () {
      var codeEl = popup.querySelector('[data-copy-code]');
      var code = codeEl ? codeEl.textContent.trim() : '';
      var done = function () {
        var original = copyButton.textContent;
        copyButton.textContent = 'Gekopieerd!';
        setTimeout(function () {
          copyButton.textContent = original;
        }, 2000);
      };
      if (navigator.clipboard && code) {
        navigator.clipboard.writeText(code).then(done).catch(done);
      } else {
        done();
      }
    });
  }

  if (popup.dataset.showNow === 'true') {
    show();
    try {
      window.localStorage.setItem(DISMISS_KEY, '1');
    } catch (e) {}
    return;
  }

  var alreadyDismissed = false;
  try {
    alreadyDismissed = window.localStorage.getItem(DISMISS_KEY) === '1';
  } catch (e) {}

  if (!alreadyDismissed) {
    setTimeout(show, 8000);
  }
})();
